import { push, goBack } from 'react-router-redux';
import { stringify as qsStringify } from 'querystring';

import {messagesDictionary} from './../../conf/messagesDictionary';
import {nbMaxAccountToPair} from './../../conf/config';

import firebaseApp from './../../utils/firebase/firebase';
import * as firebase from 'firebase';

import * as types from './userActionTypes';

import SingletonLibrary from './../../library/SingletonLibrary';
import { checkSubscriptionStatus } from './../Auth/authActions';

const createUserInSuccess = (userId) => {
    return {
        type: types.CREATEUSER_SUCCESS,
        userId
    }
}
  
const createUserInProgress = () => {
    return {
        type: types.CREATEUSER
    }
}
  
export const createUserInError = (errorMessage, errorCode) => {
    // translate errorMessage in French when message is returned from Firebase (based on Error Code)
    if(errorCode!=='' && typeof messagesDictionary['FIREBASE_ERROR_CODE'].hasOwnProperty(errorCode)){
        errorMessage = messagesDictionary['FIREBASE_ERROR_CODE'][errorCode];
    }
    return {
        type: types.CREATEUSER_ERROR,
        errorMessage,
        errorCode
    }
}

const getUserInSuccess = (username, email, emailParent, city, birthday, avatarId, commentCGURead, isAdmin, lastTimeLoggedIn) => {
    return {
        type: types.GETUSER_SUCCESS,
        username,
        email,  
        emailParent,
        city, 
        birthday, 
        avatarId,
        commentCGURead,
        isAdmin,
        lastTimeLoggedIn
    }
}

const getUserInProgress = () => {
    return {
        type: types.GETUSER
    }
}

const getUserInError = (getErrorMessage) => {
    return {
        type: types.GETUSER_ERROR,
        getErrorMessage
    }
}

export const getCurrentUser = (uid) => {
    return (dispatch) => {
        dispatch(getUserInProgress()); 
        firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }`).once('value').then((snapshot) => {
            const username = (snapshot.val() && snapshot.val().publicData.displayName) || '';
            const email = (snapshot.val() && snapshot.val().email) || '';
            const emailParent = (snapshot.val() && snapshot.val().emailParent) || '';
            const city = (snapshot.val() && snapshot.val().city) || '';
            const birthday = (snapshot.val() && snapshot.val().birthday) || '';
            const avatarId = (snapshot.val() && snapshot.val().publicData.avatar) || '0';
            const commentCGURead = (snapshot.val() && snapshot.val().commentCGURead) || false;
            const isAdmin = (snapshot.val() && snapshot.val().publicData.isAdmin) || false; 
            const lastTimeLoggedIn = (snapshot.val() && snapshot.val().lastTimeLoggedIn) || new Date().getTime();
            dispatch(getUserInSuccess(username, email, emailParent, city, birthday, avatarId, commentCGURead, isAdmin, lastTimeLoggedIn));
        })
        .catch((error) => {
            dispatch(getUserInError(error.message, error.code))
        });
    }
}

const sendWelcomeMail = (emailParent, username, birthday, city) => {

    const formData = {
        emailParent,
        username,
        birthday,
        city
    };

    firebaseApp.auth().currentUser.getIdToken()
            .then((fbIdToken) => {
   
                    SingletonLibrary
                        .getAxiosInstance
                        .post('/send-welcome-email',qsStringify(formData),
                        {
                          headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'fbkm-access-token':fbIdToken
                          }
                        });
            });
}
  
export function createUser(username, password, password_confirm, avatar, birthday, city, email_parent, optin_commercial) {
    return (dispatch) => {
        dispatch(createUserInProgress());
        
        const email = username.trim().toLowerCase().replace(/ /g, '_') + '@kidsmatin.com';
        email_parent = email_parent.toLowerCase();

        const formData = {
            email: email_parent
        };

        SingletonLibrary
            .getAxiosInstance
            .post('/account/check-number-account', qsStringify(formData),{ headers: { 'Content-Type': 'application/x-www-form-urlencoded' }} )
            .then((result)=>{
                if(result.data[0].account < nbMaxAccountToPair)
                {
                    return firebaseApp.auth().createUserWithEmailAndPassword(email, password)
                }
                else {
                    let errorMessage = new Error("");
                    errorMessage.code = "auth/all-slots-used";
                    throw errorMessage;
                }
                
            })
            .then(()=>{
                return firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }`).set({
                    publicData : {
                        displayName: username.trim(),
                        avatar
                    },
                    email,
                    birthday,
                    city,
                    emailParent:email_parent,
                    optinCommercial: optin_commercial,
                    points:{
                        totalPoints: 0,
                        currentPoints: 0
                    },
                    commentCGURead: false,
                    createdAt : new Date().getTime(),
                    lastUpdate: new Date().getTime(),
                    lastTimeLoggedIn: new Date().getTime()
                })
            })
            .then(() => {
                dispatch(
                    createUserInSuccess(firebaseApp.auth().currentUser.uid)
                );

                dispatch(
                    getCurrentUser(firebaseApp.auth().currentUser.uid)
                );

                dispatch(checkSubscriptionStatus(false)); //we do not redirect in the subscription check

                //we send the welcome mail
                sendWelcomeMail(email_parent, username, birthday, city);

                // redirect to account/profile
                dispatch(push('/account/profile'));
            })
            .catch((e)=>{
                let code = '';
                let message = e.message;

                if ( e.response.hasOwnProperty('data') && e.response.data.message !== '' && e.response.data.status === 401 ) {
                    message = e.response.data.message;
                } else if (typeof e.code !== 'undefined'){
                    code = e.code; 
                }
                dispatch(createUserInError(message, code))
            });
    }
}

function editUserPassword(password_old, password){
    const credentials = firebase
        .auth
        .EmailAuthProvider
        .credential(
            firebaseApp
                .auth()
                .currentUser
                .email,
            password_old
        );
    
    return firebaseApp
        .auth()
        .currentUser
        .reauthenticateAndRetrieveDataWithCredential(credentials)
        .then(() => {
            return firebaseApp
            .auth()
            .currentUser
            .updatePassword( password )
        });
}

function editUserData(payload) {
    return firebaseApp
        .database()
        .ref(`users/${ firebaseApp.auth().currentUser.uid }` )
        .update(payload)
}

export function updateUserInformation(password_old, password, avatar, birthday, city) {
    return (dispatch, getState) => {

        const payload = {};
        let updateNeeded = false;
        var promisePassword = Promise.resolve(1);
        var promiseData = Promise.resolve(1);

        if(getState().user.avatar !== avatar)
        {
            payload[`/publicData/avatar`] = avatar;
            updateNeeded = true;
        }

        if(getState().user.birthday !== birthday)
        {
            payload[`/birthday`] = birthday;
            updateNeeded = true;
        }

        if(getState().user.city !== city)
        {
            payload[`/city`] = city;
            updateNeeded = true;
        }

        if(password !== '')
        {
            promisePassword = editUserPassword(password_old, password);
        }
        
        if(updateNeeded)
        {
            payload[`/lastUpdate`] = new Date().getTime();
            promiseData = editUserData(payload);
        }

        Promise.all([promisePassword, promiseData])
            .then(() => {
                dispatch( getCurrentUser() );
                dispatch( goBack() );
            })
            .catch((err) => {
                dispatch( createUserInError(err.message, err.code) );
            });
    } 
}

const readCGUInSuccess = () => {
    return {
        type: types.USER_READ_CGU
    }
}

const readCGUInError = (errorMessage) => {
    return {
        type: types.USER_READ_CGU_ERROR,
        errorMessage
    }
}

export const readCGU = () => {
    return (dispatch) => {
        firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/commentCGURead`).set(true)
            .then(() => {
                dispatch(readCGUInSuccess())
            })
            .catch((error) => {
                dispatch(readCGUInError(error.message))
            });
    }
}

/** 
 * this function is used to set an array of errors into the state if we detect that the create user form has incorrect datas
*/
export const createUserErrors = (errors) => {
    return {
        type: types.CREATEUSER_ERROR,
        errorMessage: errors
    }
}

export const clearErrors = () => {
    return{
        type: types.CLEAR_ERRORS
    }
}

export const getUnreadMessageFromJournalist = (hasUnreadJournalistMessage) => {
    return{
        type: types.HAS_UNREAD_JOURNALIST_MESSAGE,
        hasUnreadJournalistMessage
    }
}



// WEBPACK FOOTER //
// ./src/components/user/userActions.js